export default "__VITE_ASSET__B2e2DN6F__"